// Video/Lecture Actions
export const FETCH_VIDEOS = 'FETCH_VIDEOS';
export const FETCH_VIDEOS_SUCCESS = 'FETCH_VIDEOS_SUCCESS';
export const FETCH_VIDEOS_FAIL = 'FETCH_VIDEOS_FAIL';

export const FETCH_VIDEO_DETAIL = 'FETCH_VIDEO_DETAIL';
export const FETCH_VIDEO_DETAIL_SUCCESS = 'FETCH_VIDEO_DETAIL_SUCCESS';
export const FETCH_VIDEO_DETAIL_FAIL = 'FETCH_VIDEO_DETAIL_FAIL';

export const PLAY_VIDEO = 'PLAY_VIDEO';
export const PAUSE_VIDEO = 'PAUSE_VIDEO';
export const SET_VIDEO_PROGRESS = 'SET_VIDEO_PROGRESS';
export const SET_VIDEO_VOLUME = 'SET_VIDEO_VOLUME';
